// extracted by mini-css-extract-plugin
export default {"msgcontainer":"MyProfileStyles_msgcontainer__GwR5l","message":"MyProfileStyles_message__Ake-T"};